"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectShowPreviewTextOption')(function selectShowPreviewTextOption(showPreviewText, state) {
    var optionState = state.optionState;
    optionState.showPreviewTextInListView = showPreviewText;
}));
//# sourceMappingURL=selectShowPreviewTextOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-preview-option/lib/actions/selectShowPreviewTextOption.js
// module id = 5108
// module chunks = 2